module.exports = __webpack_public_path__ + "static/media/empty_offers.9951079c.svg";